export function parseSchemas(inputString) {
    function decToBinary(dec, length) {
        let bin = (dec >>> 0).toString(2);
        return "0".repeat(Math.abs(bin.length - length)) + bin;
    }

    let orig = "";
    class Test {
        constructor(name, alts) {
            this.name = name;
            this.alts = alts;
        }
    }
    let testsClass = [];
    let tests = inputString.split(" ");
    let sum;
    let result = [];
    let schema = "";
    let schemaBoolean = "";
    let index;
    tests.forEach((t, index) => {
        let test_alt = t.split("_");
        testsClass.push(new Test(test_alt[0], test_alt.length - 1));
        orig += test_alt.length - 1 > 0 ? "1" : "";
    })

    sum = parseInt(orig, 2);
    if (orig.length < 1) {
        sum = 0;
    }
    for (let i = 0; i < sum + 1; i++) {
        index = 0;
        for (let n = 0; n < testsClass.length; n++) {
            schema += testsClass[n].name;

            if (testsClass[n].alts > 0) {
                if (decToBinary(i, orig.length)[index] === "1") {
                    schema += "_Alt";
                    schemaBoolean += "true";
                } else { schemaBoolean += "false"; }
                index++;

            } else {
                schemaBoolean += "false";
            }

            if (n < testsClass.length - 1) {
                schema += " ";
                schemaBoolean += " ";
            }
        }
        result.push({ schema, schemaBoolean });
        schema = "";
        schemaBoolean = "";
    }
    return result;
}

// function res(txt) {
//     let sum = 0
//     let new_ar = txt.split(' ')
//     let index = 0
//     new_ar.map((value)=>{
//         if (value.includes('_alt')) {        
//             sum+=Math.pow(2,index++)
//         }
//     })

//     let result_arr = []
//     for (let i = 0; i <= sum; i++) {
//         let counter = 0
//         let temp_arr = []
//         let bin = '0'.repeat(sum.toString(2).length - i.toString(2).length) + i.toString(2)
//         new_ar.map((value)=>{
//             if (value.includes('_alt')) {
//                 if (bin.charAt(counter++)==='1') {
//                     temp_arr.push(value)
//                 } else {
//                     temp_arr.push(value.replace('_alt',''))
//                 }
//             } else {
//                 temp_arr.push(value)
//             }
//         })
//         result_arr.push(temp_arr)
//     }
// return result_arr
// }

// let r2 = res('verse2_alt verse3_alt chorus1 verse1_alt verse2_alt verse3_alt chorus1 verse1_alt')
// console.log(r2)


// function findIndexes(schemaArr) {
//     let indexes = []
//     for (let i = 0; i < schemaArr.length; i++) {
//         if (schemaArr[i].includes('_alt')) {
//             indexes.push(i)
//         }
//     }
//     return indexes
// }

// function generate(schema) {
//     let schemaArr = schema.split(' ')
//     let blank = schemaArr.map((value) => {
//         if (value.includes('_alt')) {
//             let altRemoved = value.replace('_alt', '')
//             return altRemoved
//         }
//         return value
//     })
//     let indexesArr = findIndexes(schemaArr)
//     let result = []
//     result.includes(schema) ? null : result.push(schema)
//     result.includes(blank.join(' ')) ? null : result.push(blank.join(' '))

//     for (let i = 0; i < indexesArr.length; i++) {
//         let tempTwo = [...schemaArr]
//         let tempBlank = [...blank]
//         tempTwo[indexesArr[i]] = tempTwo[indexesArr[i]].replace('_alt', '')
//         tempBlank[indexesArr[i]] += '_alt'
//         result.includes(tempTwo.join(' ')) ? null : result.push(tempTwo.join(' '))
//         result.includes(tempBlank.join(' ')) ? null : result.push(tempBlank.join(' '))
//     }
//     return result
// }

// console.log(generate('intro_alt verse1_alt intro_alt intro_alt intro_alt'))